// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2pkhK","dragIcon":"SortableItem_dragIcon__V3yRF","disabled":"SortableItem_disabled__1YI8X"};